var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view"},[_c('h1',{staticClass:"ui header"},[_vm._v("Server Error (502)")]),_c('p',[_c('router-link',{staticClass:"ui blue button",attrs:{"to":_vm.$route.query.redirect}},[_vm._v("Reload page")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }